<template>
  <div class="post-preview">
    <i class="el-icon-document-copy post-preview-icon"></i>
    <div class="post-preview-content">
      <div class="post-preview-header" v-if="collectionTitle || groupTitle">
        <span v-if="collectionTitle" class="collection-name">{{ collectionTitle }}</span>
        <span v-if="groupTitle" class="group-name">{{ groupIndex !== undefined ? `${groupIndex + 1}. ` : '' }}{{ groupTitle }}</span>
      </div>
      <div class="post-preview-title">{{ postTitle || 'Untitled Post' }}</div>
      <div class="quiz-progress" v-if="quizCount !== undefined && quizCount > 0">
        <div class="quiz-segments">
          <div
            v-for="index in quizCount"
            :key="index"
            :class="['quiz-segment', index <= completedQuizCount ? 'quiz-segment-completed' : 'quiz-segment-incomplete']"
          ></div>
        </div>
        <i v-if="completedQuizCount === quizCount" class="el-icon-circle-check completed-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostPreview',
  props: {
    postTitle: {
      type: String,
      default: ''
    },
    collectionTitle: {
      type: String,
      default: ''
    },
    groupTitle: {
      type: String,
      default: ''
    },
    groupIndex: {
      type: Number,
      default: undefined
    },
    quizCount: {
      type: Number,
      default: undefined
    },
    postData: {
      type: Object,
      default: null
    }
  },
  computed: {
    completedQuizCount() {
      // Use quiz_complete_count if available
      if (this.postData?.quiz_complete_count !== undefined) {
        return this.postData.quiz_complete_count
      }
      // Fallback to counting quiz_answers
      if (!this.postData?.view_info?.quiz_answers) {
        return 0
      }
      return Object.keys(this.postData.view_info.quiz_answers).length
    }
  }
}
</script>

<style scoped>
.post-preview {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 8px;
  margin-top: 8px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  isolation: isolate;
}

.post-preview:hover {
  background: #ffe7ba;
  border-color: #ffa940;
  box-shadow: 0 2px 8px rgba(250, 173, 20, 0.15);
}

.post-preview-icon {
  font-size: 20px;
  color: #fa8c16;
  flex-shrink: 0;
  margin-top: 2px;
}

.post-preview-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.post-preview-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #8c8c8c;
  flex-wrap: wrap;
}

.group-name {
  color: #8c8c8c;
}

.collection-name {
  font-weight: 600;
  color: #595959;
}

.post-preview-title {
  font-size: 14px;
  font-weight: 600;
  color: #fa8c16;
  line-height: 1.4;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quiz-progress {
  display: flex;
  align-items: center;
  margin-top: 6px;
  gap: 6px;
}

.quiz-segments {
  display: flex;
  flex: 1;
  gap: 4px;
}

.quiz-segment {
  flex: 1;
  height: 3px;
  border-radius: 1.5px;
}

.quiz-segment-completed {
  background-color: #409EFF;
}

.quiz-segment-incomplete {
  background-color: #d9d9d9;
}

.completed-icon {
  font-size: 16px;
  color: #52c41a;
}
</style>
